export const CATALOG_FEATURE_NAME = 'catalog';
